<template>
  <div>
    <component
      :is="resolveSectionComponent(section.__typename as SectionComponents)"
      v-for="(section, idx) in data?.page!.hero"
      :key="section.__typename"
      :index="idx"
      :data="section"
    />

    <div v-if="Array.isArray(data?.page!.blocks) && data?.page!.blocks.length">
      <component
        :is="resolveSectionComponent(section.__typename as SectionComponents)"
        v-for="(section, index) in data.page.blocks"
        :key="section.__typename"
        :index="data?.page!.hero?.length > 0 ? index + 1 : index"
        :data="section"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { toHead } from 'vue-datocms'
import type { SectionComponents } from '~/types/components'
import { ModelApiKey } from '~/types/models'
import type { StringMultiLocaleField, BooleanTypeMultiLocaleField } from '~/types/generated'

const { locale } = useI18n()
const route = useRoute()

const { throwError } = useNuxtError()
const { resolveSectionComponent } = useResolveComponent()
const config = useRuntimeConfig()

const { data, error } = await useAsyncGql('page', {
  locale,
  slug: route.params.slug as string,
  options: {
    initialCache: false
  }
})

if (!data?.value!.page || error.value) {
  throwError(404)
}

if (data?.value!.page) {
  route.meta.nuxtI18n = useLocaleSlugs(
    data.value.page._allSlugLocales as StringMultiLocaleField[],
    data.value.page._allPublishTranslationLocales as BooleanTypeMultiLocaleField[]
  )
}

const datoHead = toHead((data.value as any).page.seo)
const i18nHeadLinks = useLocaleHeadLinks(ModelApiKey.Page)

useHead(() => {
  const metaTags = [...(datoHead.meta || [])]

  // Check for noindex
  if ((data.value as any).page.noIndex) {
    metaTags.push({ name: 'robots', hid: 'robots', content: 'noindex' })
  }

  return {
    title: datoHead.title,
    link: [...i18nHeadLinks],
    meta: [
      {
        hid: 'og:url',
        property: 'og:url',
        content: config.public.appUrl + route.fullPath
      },
      ...metaTags
    ]
  }
})
</script>
